module.exports = __webpack_public_path__ + "img/1440.3cadcc48.jpg";